module.exports = __webpack_public_path__ + "static/img/Generalledgercard_bg.05e2f6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Generalledgercard_bg.png
// module id = OtWy
// module chunks = 0